export default "__VITE_ASSET__DbdEWco4__"